import { render, staticRenderFns } from "./DepositView.vue?vue&type=template&id=945cdcd4&scoped=true&"
import script from "./DepositView.vue?vue&type=script&lang=js&"
export * from "./DepositView.vue?vue&type=script&lang=js&"
import style0 from "./DepositView.vue?vue&type=style&index=0&id=945cdcd4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "945cdcd4",
  null
  
)

export default component.exports